<div class="px-7 mt-3 pb-20">
   <dx-data-grid #grid>
      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxi-column [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false" width="40" cellTemplate="spedTemplate"></dxi-column>
      <div *dxTemplate="let cellInfo of 'spedTemplate'">
         <span *ngIf="cellInfo.data.stato_trasferimento == 'spedito' && dir == DIREZIONE_TRASFERIMENTO.INGRESSO"><i class="fas fa-exclamation-circle fa-lg animate-pulse" style="color: #ff0000;"></i></span>
      </div>


      <dxi-column caption="Vedi" width="85" cellTemplate="bntVediTemplate"
                  alignment="center"
                  [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false"></dxi-column>
      <div *dxTemplate="let item of 'bntVediTemplate'">
         <a type="button" class="btn-tbl icon-modifica" *ngIf="dir == DIREZIONE_TRASFERIMENTO.USCITA"
            [routerLink]="'../' + [item.data.id]" [queryParams]="{dir:dir}">
<!--            <i class="fa-solid fa-pen"></i>-->
         </a>

         <a type="button" class="btn-tbl icon-modifica" *ngIf="dir == DIREZIONE_TRASFERIMENTO.INGRESSO"
            [routerLink]="'../' + [item.data.id] + '/riepilogo-in'" [queryParams]="{dir:dir, pVenditaSource:item.data.pvendita}">
<!--            <i class="fa-solid fa-pen"></i>-->
         </a>
      </div>

      <dxi-column dataField="display_id" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Codice" width="100"></dxi-column>
      <dxi-column dataField="stato" alignment="center" caption="Stato" cellTemplate="statoTemplate" [allowHeaderFiltering]="true" [allowFiltering]="true">
         <dxo-header-filter
            [dataSource]="headerFilterStatoData">
         </dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let item of 'statoTemplate'">
         <span *ngIf="item.data.stato == 'bozza'" class="badgered">Bozza</span>
         <span *ngIf="item.data.stato == 'completo'" class="badgegreen">Completo</span>
         <span *ngIf="item.data.stato == 'confermato'" class="badgeyellow">Confermato</span>
      </div>

      <dxi-column dataField="stato_trasferimento" width="170" alignment="center" caption="Stato Trasferimento" cellTemplate="statoTrasferimentoTemplate" [allowHeaderFiltering]="true" [allowFiltering]="true">
         <dxo-header-filter
            [dataSource]="headerFilterTrasfData">
         </dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let item of 'statoTrasferimentoTemplate'">
         <span *ngIf="item.data.stato_trasferimento == 'preparazione'" class="badgered">In Preparazione</span>
         <span *ngIf="item.data.stato_trasferimento == 'consegnato'" class="badgegreen">Consegnato</span>
         <span *ngIf="item.data.stato_trasferimento == 'spedito'" class="badgeyellow">Spedito</span>
      </div>

      <dxi-column dataField="data_creazione" alignment="center" dataType="startDate" [allowHeaderFiltering]="false" [allowFiltering]="true" [allowSearch]="false" caption="Data Operazione"></dxi-column>
      <dxi-column dataField="data_spedizione" alignment="center" dataType="startDate" [allowHeaderFiltering]="false" [allowFiltering]="true" [allowSearch]="false" caption="Data Spedizione"></dxi-column>
      <dxi-column *ngIf="dir == DIREZIONE_TRASFERIMENTO.INGRESSO" dataField="p_vendita_name" dataType="string" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Partenza"></dxi-column>
      <dxi-column *ngIf="dir == DIREZIONE_TRASFERIMENTO.USCITA" dataField="p_vendita_dst_name" dataType="string" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Destinazione"></dxi-column>
      <dxi-column dataField="qta_trasf" caption="Quantità" width="120" alignment="center" [allowHeaderFiltering]="false" [allowFiltering]="true" [allowSearch]="false" ></dxi-column>
      <dxi-column dataField="note" caption="Note" width="150" [allowHeaderFiltering]="false" [allowFiltering]="true" ></dxi-column>


      <dxi-column cellTemplate="ddtTemplate" caption="DDT" alignment="center" [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false" ></dxi-column>
      <div *dxTemplate="let item of 'ddtTemplate'">
         <button class="btn-tbl btn-primary" *ngIf="(item.data.ddt && dir == DIREZIONE_TRASFERIMENTO.USCITA) || (item.data.ddt && dir == DIREZIONE_TRASFERIMENTO.INGRESSO && item.data.stato_trasferimento == STATO_TRASFERIMENTO.CONSEGNATO) "
                 (click)="clickScaricaDdt(item.data.ddt)">
            <i class="fa-solid fa-file-invoice"></i>
         </button>
      </div>

      <dxi-column *ngIf="dir == DIREZIONE_TRASFERIMENTO.USCITA" cellTemplate="eliminaTemplate" caption="Elimina" alignment="center" width="120" [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false"></dxi-column>
      <div *dxTemplate="let item of 'eliminaTemplate'">
         <button class="btn-tbl-trash" *ngIf="item.data.stato == Ordine.StatoOrdine.BOZZA"
                 (click)="clickEliminaTrasferimento(item.data.id)">
            <i class="fa-light fa-trash-can"></i>
         </button>
      </div>
   </dx-data-grid>
</div>